import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../validators/custom-validators';
import { User } from '../../classes/user';
import { Subject } from 'rxjs/Subject';
import { SigninSignupService } from '../../signin-signup.service';
import { SigninSignupOptions } from '../../signin-signup-options.interface';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class SignupComponent implements OnInit {

  userCredentialsPage = true;
  userDetailsPage = false;
  verificationPage = false;
  isGettingCode: boolean = false;

  signUpForm: FormGroup;
  userDetailsForm: FormGroup;
  verificationForm: FormGroup;


  inputChangeListener: Subject<any> = new Subject<any>();
  user = new User();
  newUser: any;
  newUserWithPhoneNumber: any;
  submitted: boolean = false;
  userDetailsSubmitted: boolean = false;
  verificationSubmitted: boolean = false;
  showError: boolean = false;
  showCorrectCode: boolean = false;
  fillEmailId: boolean = false;

  constructor(public formBuilder: FormBuilder, public ref: ChangeDetectorRef,
              public router: Router, private activatedRoute: ActivatedRoute,
              public signinSignupService: SigninSignupService) { }

  ngOnInit() {
    if(this.activatedRoute.snapshot.queryParams['fillEmailId']) {
      this.fillEmailId = true;
      this.user.emailAddress = this.activatedRoute.snapshot.queryParams['fillEmailId'];
    }
    this.signUpForm = this.formBuilder.group({
      emailAddress: [this.user.emailAddress, Validators.compose([Validators.required, CustomValidators.email])],
      password: [this.user.password, Validators.compose([Validators.required, Validators.minLength(6), Validators.pattern('^(?=.*[0-9])(?=.*[a-zA-Z]).{6,50}$')])]
    });

    this.userDetailsForm = this.formBuilder.group({
      fullName: [this.user.fullName, Validators.compose([Validators.required, CustomValidators.fullName, Validators.maxLength(59), Validators.pattern('^[a-zA-Z ]+$')])],
      companyName: [this.user.companyName, Validators.compose([Validators.required])],
      phoneNumber: [this.user.phoneNumber, Validators.compose([Validators.required, CustomValidators.usaPhoneNumber])]
    });

    this.verificationForm = this.formBuilder.group({
      verificationCode: [this.user.verificationCode, Validators.compose([Validators.required, Validators.maxLength(4), CustomValidators.verificationCode])]
    });
    (<any>window).Events.publish('isSignUpPopupOpen', true);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.signinSignupService.focusFirstEmptyElement('sign-up-name-input');
    }, 0);
    (<any>window).Events.publish('segment', 'Signup Start');
  }

  @Input() set options(opt: SigninSignupOptions) {
    this.attachChanges(opt);
  }

  @Input() set featureObject(value) {
    this.signinSignupService.featureObject = value;
  }

  // Attach all the changes received in the options object
  attachChanges(options): void {
    Object.keys(options).forEach(a => {
     if (this.signinSignupService.hasOwnProperty(a)) this.signinSignupService[a] = options[a]
    });
  }

  onSubmit() {
    this.submitted = true;
    let w = (<any>window);
    w.Events.publish('detectChanges'); //Angular 2 map-app specially
    if (this.signUpForm.valid) {
      this.signinSignupService.login(this.user, false).subscribe(
        result => {
          if (result) {
            this.submitted = false;
            w.Events.publish('SigninComplete', result);
            this.closePopup();
          }
        },
        error => {
          this.nextPage();
        }
      );
    }
  }

  onSubmitUserDetails() {
    let w = (<any>window);
    this.userDetailsSubmitted = true;
    if(this.userDetailsForm.valid) {
      this.isGettingCode = true;
      this.newUserWithPhoneNumber = {
        emailAddress: this.user.emailAddress,
        phoneNumber: this.addIsdCodeToPhoneNumber()
      };
      this.signinSignupService.getVerificationCode(this.newUserWithPhoneNumber).subscribe((response: any) => {
        if (response) {
          w.Events.publish('notificationInfo', 'A four digit code will be sent to your phone.');
          this.user.requestKey = response.requestKey;
        }
      }, (error) => {
        if(error.status === 403 || error.status === 401) {
          w.Events.publish('notificationError', "You've clicked 'resend code' too many times. Please wait 5 or 10 minutes and try again.");
        } else if(error.status === 400 && (error._body || (error.error && error.error.redirectUrl))) {
          if(error._body) {
            let bodyJson = typeof error._body === 'object' ? error._body : JSON.parse(error._body);
            if(bodyJson.redirectUrl) {
              this.router.navigateByUrl(bodyJson.redirectUrl);
            }
          } else if(error.error && error.error.redirectUrl) {
            this.router.navigateByUrl(error.error.redirectUrl);
          }
        } else {
          throw error;
        }
      }, () => {
        this.isGettingCode = false;
        this.nextPage();
      });
    }
    (<any>window).Events.publish('detectChanges'); //Angular 2 map-app specially
  }

  addIsdCodeToPhoneNumber() {
    if (this.user.phoneNumber.charAt(0) === '+') {
      this.user.phoneNumber = this.user.phoneNumber.replace(/\D+/g, '')
      return ('+' + this.user.phoneNumber);
    } else {
      this.user.phoneNumber = this.user.phoneNumber.replace(/\D+/g, '');
      if (this.user.phoneNumber.length === 11 || this.user.phoneNumber.length === 12) {
        return ('+' + this.user.phoneNumber);
      } else if (this.user.phoneNumber.length === 10) {
        return ('+1' + this.user.phoneNumber);
      } else {
        return (this.user.phoneNumber);
      }
    }
  }

  onSubmitVerificationCode() {
    let w = (<any>window);
    this.verificationSubmitted = true;
    if (this.verificationForm.valid) {
      this.newUser = {
        emailAddress: this.user.emailAddress,
        fullName: this.user.fullName,
        password: this.user.password,
        code: this.user.verificationCode,
        company: this.user.companyName,
        requestKey: this.user.requestKey
      };
      this.signinSignupService.signUpUser(this.newUser).subscribe((res: any) => {
        w.Events.publish('SignupComplete', res);
        this.closePopup();
      }, (error) => {
        w.Events.publish('SignupError', error);
        this.showError = true;
      });
      this.nextPage();
    }
    (<any>window).Events.publish('detectChanges'); //Angular 2 map-app specially
  }

  closePopup() {
    let w = (<any>window);
    w.Events.publish('updatePopupRoute', null);
    w.Events.publish('resetFeatureExecution');
    (<any>window).Events.publish('detectChanges'); //Angular 2 map-app specially
  }

  closePopupKeydown(event) {
    this.signinSignupService.isTabKeyHit(event) || (this.signinSignupService.isEnterKeyHit(event) && this.closePopup());
  }

  openLoginPopup() {
    (<any>window).Events.publish('updatePopupRoute', 'log-in');
  }

  nextPage() {
    if (this.userCredentialsPage && this.signUpForm.valid) {
      this.userCredentialsPage = false;
      this.userDetailsPage = true;
      this.verificationPage = false;
    }
    else if (this.userDetailsPage && this.userDetailsForm.valid) {
        this.userCredentialsPage = false;
        this.userDetailsPage = false;
        this.verificationPage = true;
    }
    (<any>window).Events.publish('detectChanges'); //Angular 2 map-app specially
  }

  openTermsPopup() {
    (<any>window).Events.publish('updatePopupRoute', {
      popup: 'sign-up',
      innerPopup: 'terms-conditions'
    });
  }

  goBack() {
    if (this.userDetailsPage) {
      this.userCredentialsPage = true;
      this.userDetailsPage = false;
      (<any>window).Events.publish('updatePopupRoute', 'sign-up');
    } else {
      this.verificationPage = false;
      this.userDetailsPage = true;
    }
    (<any>window).Events.publish('detectChanges'); //Angular 2 map-app specially
  }

  ngOnDestroy() {
    (<any>window).Events.publish('isSignUpPopupOpen', false);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/signin-signup/components/signup/signup.component.ts